import { take, call, put, select } from 'redux-saga/effects';
import { agents as actionTypes } from '$constants/action-types';
import * as actions from '$actions/agents';
import { errors } from '../lib/normalize';
import uploadFile from '../lib/upload-file';
import axios from 'axios';
import { requirePassword } from './root';
import { showNotification } from '$actions/root';

const fetchCurrent = () => axios.get(`/customers/me`);
const update = params => axios.patch(`/customers/me`, params);

function* watchFetchCurrent() {
  while(true) {
    const action = yield take(actionTypes.FETCH_CURRENT);

    yield put(actions.fetchCurrentRequest());
    const { data } = yield call(fetchCurrent);
    const { first_name, last_name, locale, email, time_zone, profile_picture_url, notification_settings, customer_role, permissions,report_emails } = data.data;
    const result = {
      firstName: first_name,
      lastName: last_name,
      locale: locale,
      email: email,
      timeZone: time_zone,
      photoUrl: profile_picture_url,
      notificationSettings: notification_settings,
      customerRoleId: customer_role ? customer_role.id : null,
      permissions: permissions,
      reportEmails: report_emails
    };

    yield put(actions.fetchCurrentSuccess(result));
  }
}

function* watchUpdate() {
  while(true) {
    const action = yield take(actionTypes.UPDATE);
    const current = yield select(state => state.agents.current);

    yield put(actions.updateRequest());

    if (action.params.password && action.params.password !== action.params.passwordConfirmation) {
      yield put(actions.updateFailure({ passwordConfirmation: ['not match'] }));
      continue;
    }

    try {
      const params = {
        customer: {
          first_name: action.params.firstName,
          last_name: action.params.lastName,
          email: action.params.email,
          locale: action.params.locale,
          time_zone: action.params.timeZone,
          password: action.params.password,
          notification_settings: action.params.notificationSettings,
          customer_role_id: action.params.customerRoleId
        }
      };

      if (action.params.photo) {
        const key = yield call(uploadFile, 'agent', action.params.photo);
        params.customer.profile_picture_attributes = {
          s3_key: key
        };
      }

      if (action.params.email !== current.email || action.params.password) {
        params.customer.current_password = yield requirePassword();
      }

      const { data } = yield call(update, params);

      const result = {
        firstName: data.data.first_name,
        lastName: data.data.last_name,
        locale: data.data.locale,
        email: data.data.email,
        timeZone: data.data.time_zone,
        photoUrl: data.data.profile_picture_url,
        notificationSettings: data.data.notification_settings
      };

      yield put(actions.updateSuccess('Changes have been saved', result));
    } catch(e) {
      console.log(e);

      if (params.currentPassword) {
        yield put(showNotification('Current password is incorrect', 'error'));
      }

      yield put(actions.updateFailure(params));
    }
  }
}

export const watchers = [
  watchFetchCurrent,
  watchUpdate
];



// WEBPACK FOOTER //
// ./src/sagas/agents.js